@if (permissionService.checkPermissionValue({ permission: 'READ', tab: 'device' })) {
  <div class="widget-header">
    @if (isEdit) {
      <div class="container-input">
        <div class="container-input-service">
          <span class="label-select-service">Service</span>
          <div [id]="card.card" (click)="toggleSelectService()" class="input-outline-service">
            <p>
              {{
                serviceId && $unitsById()?.[serviceId]?.label
                  ? $unitsById()[serviceId].label
                  : ('CHART.GLOBAL_FLEET' | translate)
              }}
            </p>

            <mat-icon>
              {{ changingService ? 'arrow_drop_up' : 'arrow_drop_down' }}
            </mat-icon>
          </div>
          @if (changingService) {
            <div class="container-services">
              <tree
                (selectedCheckbox)="changeParent($event)"
                [displaySelected]="false"
                [closable]="false"
                [selected]="[serviceId]"
                [element]="'service'"
                selectionType="radio"
                [elementSelectedType]="'node'"
                [rootItem]="true"
                [labelSearch]="'TREE.SEARCH_SERVICE'"
                [maxHeight]="200"
                [labelRoot]="'CHART.GLOBAL_FLEET'" />
            </div>
          }
        </div>
        <div class="container-select-time">
          <span class="label-select-service">{{ 'CHART.IMMOBILIZED_SINCE' | translate }}</span>
          <mat-form-field appearance="outline">
            <mat-select [formControl]="timeImmobility">
              @for (timeOp of timeOptions | keyvalue; track timeOp) {
                <mat-option [value]="timeOp.key">
                  <span>{{ timeOp.value.text }}</span>
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    } @else {
      <h1 class="title-dashboard title-card">
        {{ 'DEVICE.IMMOBILIZED.IMMOBILIZED_DEVICE' | translate }}
        @if (serviceId && $unitsById()[serviceId]?.label) {
          <span>{{ 'COMMON.OF' | translate }} : {{ $unitsById()[serviceId].label }}</span>
        } @else {
          <span>{{ 'COMMON.OF_THE' | translate }} {{ 'DEVICE.IMMOBILIZED.ALLFLEET' | translate }}</span>
        }
        @if (timeOptions[timeImmobility?.value]) {
          <span>
            {{ 'COMMON.SINCE' | translate }}
            {{ timeOptions[timeImmobility?.value].text }}
          </span>
        }
      </h1>
    }
  </div>

  <div class="widget-content-height">
    @if ($devicesMap()) {
      @if (triplessDevices?.length > 0) {
        @for (device of triplessDevices | slice: 0 : 5; track device) {
          <device-card
            [display]="'triplessTime'"
            [d]="device.uid"
            [time]="device.timeOfInactivity"
            [isDisplayDriver]="false" />
        }
      } @else {
        <div class="missing-data-dashboard">
          <p>{{ 'DEVICE.IMMOBILIZED.NO_IMMOBILIZED_DEVICE' | translate }}</p>
        </div>
      }
    } @else {
      <widget-loader />
    }
  </div>
  @if (triplessDevices?.length > 5) {
    <div class="data-more-icon">
      <mat-icon (click)="goToTriplessDevice()" [matTooltip]="'COMMON.SEEMORE' | translate">
        more_horiz
      </mat-icon>
    </div>
  }
} @else {
  <h1 class="title-dashboard">{{ 'DEVICE.IMMOBILIZED.IMMOBILIZED_DEVICE' | translate }}</h1>
  <p class="not-allowed-text">
    {{ 'USER.NOT_ACCESS_DATA' | translate }}
    <br />
    {{ 'USER.PLEASECONTACTADMIN' | translate }}
  </p>
}
